<ion-content>
  <ng-container *ngIf="taskPublicContext.isTwitterPublicTask; else publicContextMessages">
    <ion-spinner *ngIf="!taskPublicContext.twitterPublicContextTasks; else checkListNoResults"></ion-spinner>

    <ng-template #checkListNoResults>
      <div
        class="warning-no-public-context"
        *ngIf="!taskPublicContext.twitterPublicContextTasks.length; else checkListHasResults">
        <ion-icon name="information-circle-outline"></ion-icon>&nbsp;
        <span translate="m/task-process/public-context/twitter/no-public-context"></span>
      </div>

      <ng-template #checkListHasResults>
        <div
          *ngFor="let twitterPublicContextTask of taskPublicContext.twitterPublicContextTasks"
          class="twitter-public-context"
          [class.selected-task]="
            twitterPublicContextTask.externalUrl === taskPublicContext.processedMessage?.externalUrl
          ">
          <ng-container
            *ngTemplateOutlet="messageInTask; context: { message: twitterPublicContextTask }"></ng-container>

          <ng-template #messageInTask let-message="message">
            <ng-container
              *ngIf="{
                height: messageElement.elRef?.nativeElement?.clientHeight
              } as data">
              <span class="twitter-children-timeline" [style.height.px]="data.height || 100"></span>
            </ng-container>
            <app-message-in-task-process
              #messageElement
              [message]="message"
              [taskProcessContext]="taskProcessContext"
              [isPublicContextModal]="true">
            </app-message-in-task-process>

            <ng-container *ngIf="message.groups?.length">
              <div *ngFor="let group of message.groups" class="group">
                <ng-container *ngFor="let child of group">
                  <ng-container *ngTemplateOutlet="messageInTask; context: { message: child }"></ng-container>
                </ng-container>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </ng-template>
    </ng-template>
  </ng-container>

  <ng-template #publicContextMessages>
    <div class="messages-container">
      <ion-spinner *ngIf="!taskPublicContext.processedMessage"></ion-spinner>
      <div *ngIf="taskPublicContext.rootMessage" class="root-message">
        <app-message-in-task-process
          [message]="taskPublicContext.rootMessage"
          [taskProcessContext]="taskProcessContext"
          [isPublicContextModal]="true">
        </app-message-in-task-process>
      </div>
      <div class="load-messages-button-container">
        <ion-button
          *ngIf="taskPublicContext.canLoadMessagesBefore()"
          (click)="loadMessagesBefore()"
          class="load-messages-button">
          <ion-icon slot="start" name="sync"></ion-icon>
          {{ loadNMessagesLabel }}
        </ion-button>
      </div>
      <div *ngFor="let chunk of taskPublicContext.loadedChunksBeforeProcesedMessage">
        <app-message-in-task-process
          *ngFor="let message of chunk"
          [message]="message"
          [taskProcessContext]="taskProcessContext"
          [isPublicContextModal]="true">
        </app-message-in-task-process>
      </div>
      <div *ngIf="taskPublicContext.processedMessage" class="processed-message">
        <app-message-in-task-process
          [message]="taskPublicContext.processedMessage"
          [taskProcessContext]="taskProcessContext"
          [isPublicContextModal]="true">
        </app-message-in-task-process>
      </div>
      <div *ngFor="let chunk of taskPublicContext.loadedChunksAfterProcesedMessage">
        <app-message-in-task-process
          *ngFor="let message of chunk"
          [message]="message"
          [taskProcessContext]="taskProcessContext"
          [isPublicContextModal]="true">
        </app-message-in-task-process>
      </div>
    </div>
  </ng-template>
  <ion-infinite-scroll (ionInfinite)="loadMessagesAfter($event)" threshold="1px">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
